import React from "react";
import "./gifsection.css";

function GifSection() {
  return (
    <section className="gif-section" id="celebration">
      <div className="gif-content">
        {/* <h2>Celebrate Every Moment with Muhurtmedh</h2> */}
        <img src={`${process.env.PUBLIC_URL}/images/gifL.gif`} />
        <img src={`${process.env.PUBLIC_URL}/images/imageU.gif`} />
        <img src={`${process.env.PUBLIC_URL}/images/gifR.gif`} />
      </div>
    </section>
  );
}

export default GifSection;
